module.exports = __webpack_public_path__ + "media/images/swines/Newborn piglets nursing.jpg";